<template>
  <div>
    <div class="px-4 pb-3">
      <v-btn style="float: right" icon @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>

      <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">
        {{ edittype == 'create' ? 'เพิ่ม' : 'แก้ไข' }}ข้อมูลสาขา
      </div>
      <div class="form-control">
        <v-layout class="pa-0 ma-0" wrap row>
          <v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('code') }">
            <label>{{ $t('รหัสสาขา') }}</label>
            <input
              v-model="input.code"
              v-validate="'required'"
              :data-vv-as="$t('รหัสสาขา')"
              class="form-control"
              type="text"
              name="code"
            />
            <span v-if="errors.has('code')" class="text-error">{{ errors.first('code') }}</span>
          </v-flex>
          <v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('name') }">
            <label>{{ $t('ชื่อสาขา') }}</label>
            <input
              v-model="input.name"
              v-validate="'required'"
              :data-vv-as="$t('ชื่อสาขา')"
              class="form-control"
              type="text"
              name="name"
            />
            <span v-if="errors.has('name')" class="text-error">{{ errors.first('name') }}</span>
          </v-flex>

          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('address') }"
          >
            <label>{{ $t('สถานที่') }}</label>
            <input
              v-model="input.address"
              v-validate="'required'"
              :data-vv-as="$t('สถานที่')"
              class="form-control"
              type="text"
              name="address"
            />
            <span v-if="errors.has('address')" class="text-error">{{
              errors.first('address')
            }}</span>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn outline color="grey" @click="$emit('close')">cancel</v-btn>
          <v-btn :loading="saveloading" depressed color="primary" @click="savedata">save</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import toaMegapaintApi from '../../../../api/toa-mega-paint'
export default {
  props: ['edittype', 'editdata'],
  data() {
    return {
      saveloading: false,
      input: {
        id: '',
        code: '',
        name: '',
        address: ''
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.edittype == 'edit') {
      this.input = {
        id: this.editdata.id,
        code: this.editdata.code,
        name: this.editdata.name,
        address: this.editdata.address
      }
    }
  },
  methods: {
    async savedata() {
      if (await this.$validator.validateAll()) {
        if (this.edittype == 'create') {
          this.createdata()
        } else {
          this.editbranch()
        }
      }
    },
    async editbranch() {
      var body = {
        page_id: this.selectedBot.pageid,
        ...this.input
      }
      try {
        this.saveloading = true
        await toaMegapaintApi.putMegaPaintBranch(body)
        this.$emit('onsave')
      } catch (error) {
        console.error(error)
      } finally {
        this.saveloading = false
      }
    },
    async createdata() {
      const body = {
        page_id: this.selectedBot.pageid,

        branch_list: [
          {
            code: this.input.code,
            name: this.input.name,
            address: this.input.address
          }
        ]
      }
      try {
        this.saveloading = true
        await toaMegapaintApi.postMegaPaintBranch(body)
        this.$emit('onsave')
      } catch (error) {
        console.error(error)
      } finally {
        this.saveloading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/ToaMegaPaintBranchEdit.vue